module.exports = __webpack_public_path__ + "media/images/help/about/heading-reason-2-0379b5171652f41d1763700d67ffda74.svg";